module.exports = __webpack_public_path__ + "img/regular.ddee2610.png";